export const colors = {
	'#EF5820': {
		secondary: '#F7AB8F',
		tertiary: '#FDEEE9'
	},
	'#FF5E04': {
		secondary: '#FFAF81',
		tertiary: '#FFEFE6'
	},
	'#F1780E': {
		secondary: '#F8BB87',
		tertiary: '#FEF1E7'
	},
	'#E9DE0A': {
		secondary: '#F4EF84',
		tertiary: '#FDFCE7'
	},
	'#FFDF1F': {
		secondary: '#FFEF8F',
		tertiary: '#FFFCE9'
	},
	'#F3B605': {
		secondary: '#F9DB82',
		tertiary: '#FEF8E6'
	},
	'#1E52A4': {
		secondary: '#8FA8D1',
		tertiary: '#E8EEF6'
	},
	'#066FAD': {
		secondary: '#83B7D6',
		tertiary: '#E6F1F7'
	},
	'#2AA9D3': {
		secondary: '#94D4E9',
		tertiary: '#EAF6FB'
	},
	'#D80122': {
		secondary: '#EB8090',
		tertiary: '#FBE6E9'
	},
	'#EB001B': {
		secondary: '#F5808D',
		tertiary: '#FDE5E8'
	},
	'#FF2A42': {
		secondary: '#FF94A0',
		tertiary: '#FFEAEC'
	},
	'#F3A2B2': {
		secondary: '#F9D0D8',
		tertiary: '#FEF6F7'
	},
	'#813D88': {
		secondary: '#C09EC3',
		tertiary: '#F2ECF3'
	},
	'#610DF4': {
		secondary: '#B086F9',
		tertiary: '#EFE7FE'
	},
	'#D2B8F8': {
		secondary: '#E8DBFB',
		tertiary: '#FBF8FE'
	},
	'#18704B': {
		secondary: '#8BB7A5',
		tertiary: '#E8F1ED'
	},
	'#8DBE09': {
		secondary: '#C6DF84',
		tertiary: '#F4F8E6'
	},
	'#21D863': {
		secondary: '#90EBB1',
		tertiary: '#E9FBEF'
	},
}
